import http from "./http";
import heavyHttp from "./http-for-heavy-request";
import { AxiosError, AxiosResponse } from "axios";

// TODO: BarGraphAnalyticsDataInTheBox に name:"usedSeconds" のプロパティ不要だよね？
export type BarGraphAnalyticsData = { data: [number, number][] }[];
export const fetchBarGraphAverageAnalyticsDataByAreaId = async (areaId: string): Promise<BarGraphAnalyticsData> => {
    const res: { data: [number, number][] } | undefined = await http
        .get(`/v1/toilets/${areaId}/used_percentage_average`)
        .then((response: AxiosResponse) =>
            response.status === 204 ? undefined : (response.data as { data: [number, number][] }),
        )
        .catch((error: AxiosError) => {
            throw error;
        });

    if (res === undefined) {
        return [{ data: [[0, 0]] }];
    }

    return [res];
};
export const fetchBarGraphAnalyticsDataByRoomId = async (
    areaId: string,
    roomId: string,
): Promise<BarGraphAnalyticsData> => {
    const res: { data: [number, number][] } | undefined = await http
        .get(`/v1/toilets/${areaId}/boxes/${roomId}/used_percentage`)
        .then((response: AxiosResponse) =>
            response.status === 204 ? undefined : (response.data as { data: [number, number][] }),
        )
        .catch((error: AxiosError) => {
            throw error;
        });

    if (res === undefined) {
        return [{ data: [[0, 0]] }];
    }

    return [res];
};

export type HeatmapAnalyticsData = {
    name: string;
    data: { x: string; y: number }[];
}[];
export const fetchHeatmapAverageAnalyticsDataByAreaId = async (areaId: string): Promise<HeatmapAnalyticsData> => {
    return http
        .get(`/v1/toilets/${areaId}/used_percentage_average/group_by_day`)
        .then((response: AxiosResponse) => (response.status === 204 ? undefined : response.data))
        .catch((error: AxiosError) => {
            throw error;
        });
};
export const fetchHeatmapAnalyticsData = async (areaId: string, roomId: string): Promise<HeatmapAnalyticsData> => {
    return http
        .get(`/v1/toilets/${areaId}/boxes/${roomId}/used_percentage/group_by_day`)
        .then((response: AxiosResponse) => (response.status === 204 ? undefined : response.data))
        .catch((error: AxiosError) => {
            throw error;
        });
};

export type StaytimeSeriesList = StaytimeSeries[];
type StaytimeSeries = { name: string; data: number[] };
export const fetchStayTimeAnalyticsData = async (companyId: string): Promise<StaytimeSeriesList> => {
    return http
        .get(`/v1/companies/${companyId}/staytime`)
        .then((response: AxiosResponse) => (response.status === 204 ? undefined : response.data))
        .catch((error: AxiosError) => {
            Promise.reject(error.response ? error.response.data.errors : "TODO: Unknown Error");
        });
};

export const fetchAnalyticsDataFormattedOnCsv = async (companyId: string): Promise<string> => {
    return heavyHttp
        .get(`/v1/companies/${companyId}/used.csv`)
        .then((response: AxiosResponse) => (response.status === 204 ? undefined : response.data))
        .catch((error: AxiosError) => {
            Promise.reject(error.response ? error.response.data.errors : "TODO: Unknown Error");
        });
};

export const fetchAnalyticsDataByAreaIdFormattedOnCsv = async (areaId: string): Promise<string> => {
    return http
        .get(`/v1/toilets/${areaId}/used.csv`)
        .then((response: AxiosResponse) => (response.status === 204 ? undefined : response.data))
        .catch((error: AxiosError) => {
            Promise.reject(error.response ? error.response.data.errors : "TODO: Unknown Error");
        });
};

// PV DAU はいったん落とした。復活の可能性はあるかもしれん。
// assume x is date and formatted MM/dd
// export type PVDAUSeries = { data: { x: string; y: number }[] }[];
// export const fetchPVData = async (): Promise<PVDAUSeries> => {
//     // TODO: これはもしかして website のPV・DAU一覧か...???

//     const getRandomInt = (max: number) => Math.floor(Math.random() * Math.floor(max));

//     const dateList = [
//         "9/17",
//         "9/18",
//         "9/19",
//         "9/20",
//         "9/21",
//         "9/22",
//         "9/23",
//         "9/24",
//         "9/25",
//         "9/26",
//         "9/27",
//         "9/28",
//         "9/29",
//         "9/30",
//         "10/1",
//         "10/2",
//         "10/3",
//         "10/4",
//         "10/5",
//         "10/6",
//         "10/7",
//         "10/8",
//         "10/9",
//         "10/10",
//         "10/11",
//         "10/12",
//         "10/13",
//         "10/14",
//         "10/15",
//         "10/16",
//     ];

//     return [
//         {
//             data: dateList.map((date: string, index: number) => {
//                 return {
//                     x: date,
//                     y: getRandomInt(index),
//                 };
//             }),
//         },
//     ];

//     // return http
//     //   .get(`/v1/websites/${websiteId}`)
//     //   .then((response: AxiosResponse) =>
//     //     response.status === 204 ? undefined : response.data
//     //   )
//     //   .catch((error: AxiosError) => {
//     //     Promise.reject(
//     //       error.response ? error.response.data.errors : "TODO: Unknown Error",
//     //     );
//     //   });
// };
